import { useState } from "react";
import NavBar from "../components/NavBar";
import { FaCheckCircle } from "react-icons/fa";
import SubscriptionDropdown from "../components/SubscriptionDropdown";
import "./CloudWebHosting.css";
import Footer from "../components/Footer.js";

// Plans Data
const plans = [
  {
    name: "Startup",
    prices: { "1 Month": 7.99, "6 Months": 44.99, "12 Months": 79.99 },
    badge: "",
    features: [
      "2 CPU Cores",
      "3 GB RAM",
      "100 GB NVMe Storage",
      "100 Websites",
      "100 PHP Workers",
      "Free Domain for 1 Year",
      "Unlimited SSL",
      "7-Day Horizons Trial",
      "10 Mailboxes per Website",
      "Managed WordPress Hosting",
      "CDN Included",
      "Dedicated IP Address",
      "Priority 24/7 Support",
    ],
  },
  {
    name: "Professional",
    prices: { "1 Month": 15.99, "6 Months": 89.99, "12 Months": 159.99 },
    badge: "Most Popular",
    features: [
      "4 CPU Cores",
      "6 GB RAM",
      "200 GB NVMe Storage",
      "200 Websites",
      "200 PHP Workers",
      "Free Domain for 1 Year",
      "Unlimited SSL",
      "7-Day Horizons Trial",
      "10 Mailboxes per Website",
      "Managed WordPress Hosting",
      "CDN Included",
      "Dedicated IP Address",
      "Priority 24/7 Support",
    ],
  },
  {
    name: "Enterprise",
    prices: { "1 Month": 29.99, "6 Months": 169.99, "12 Months": 299.99 },
    badge: "",
    features: [
      "6 CPU Cores",
      "12 GB RAM",
      "300 GB NVMe Storage",
      "300 Websites",
      "300 PHP Workers",
      "Free Domain for 1 Year",
      "Unlimited SSL",
      "7-Day Horizons Trial",
      "10 Mailboxes per Website",
      "Managed WordPress Hosting",
      "CDN Included",
      "Dedicated IP Address",
      "Priority 24/7 Support",
    ],
  },
];

const CloudHosting = () => {
  const [selectedLength, setSelectedLength] = useState("1 Month"); // Default from dropdown

  return (
    <div className="cloud-hosting-page">
      <NavBar />

      {/* HERO SECTION */}
      <div className="cloud-hero-green">
        <h1>Get online fast – at an <br /> unbeatable prices</h1>
        <p>Choose from a wide variety of services and plans to grow your idea online.</p>
        <div className="cloud-hero-tabs">
          <button className="tab active">All in one</button>
          <button className="tab">VPS hosting</button>
          <button className="tab">Cloud Hosting</button>
          <button className="tab">n8n VPS</button>
          <button className="tab">Domains</button>
        </div>
      </div>

      {/* BODY SECTION */}
      <div className="cloud-body-section">
        <h2>All in one</h2>

        {/* Subscription Dropdown */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
          <SubscriptionDropdown
            selected={selectedLength}
            onChange={(value) => setSelectedLength(value)}
          />
        </div>

        {/* Features Row */}
        <div className="cloud-features-row">
          <div className="feature-item">
            <FaCheckCircle className="feature-icon" />
            <p>24/7 support</p>
          </div>
          <div className="feature-item">
            <FaCheckCircle className="feature-icon" />
            <p>30-day money-back guarantee</p>
          </div>
          <div className="feature-item">
            <FaCheckCircle className="feature-icon" />
            <p>Cancel anytime</p>
          </div>
        </div>

        {/* PLANS SECTION */}
        <div className="plans-container">
          {plans.map((plan, index) => (
            <div key={index} className="plan-card">
              {plan.badge && <div className="plan-badge">{plan.badge}</div>}
              <h3>{plan.name}</h3>
              <p className="plan-price">
                ${plan.prices[selectedLength].toFixed(2)} / {selectedLength}
              </p>
              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <FaCheckCircle className="feature-icon" /> {feature}
                  </li>
                ))}
              </ul>
              <button className="plan-button">Get Started</button>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CloudHosting;
